import { useCallback, useMemo, useState, type FC, type PropsWithChildren } from "react";
import {
  getStoredTheme,
  persistTheme,
  resolveTheme,
  type ThemeMode,
} from "../../utils/theme/theme";
import { ThemeContext } from "./themeContext";

const ThemeProvider: FC<PropsWithChildren> = ({ children }) => {
  const [theme, setThemeState] = useState<ThemeMode>(() => resolveTheme(getStoredTheme()));

  const setTheme = useCallback((nextTheme: ThemeMode) => {
    setThemeState(nextTheme);
    persistTheme(nextTheme);
  }, []);

  const value = useMemo(
    () => ({
      theme,
      setTheme,
    }),
    [theme, setTheme],
  );

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export default ThemeProvider;
